export interface NavbarCustomization {
  backgroundColor?: string | null;
  textColor?: string | null;
}

export function buildNavbarCssRules(
  s: string,
  navbar: NavbarCustomization | null | undefined,
): string[] {
  const backgroundColor = navbar?.backgroundColor;
  const textColor = navbar?.textColor;
  const rules: string[] = [];
  if (backgroundColor) {
    rules.push(
      `${s}[data-ui="navbar"] { background-color: ${backgroundColor} !important; border-bottom: none !important; }`,
      `${s}[data-modalless-footer], ${s}[data-modalless-footer] [data-ui="sticky-footer"] { background-color: ${backgroundColor} !important; }`,
    );
  }
  if (textColor) {
    // Keep the avatar initials' contrasting color.
    // The navbar tags that subtree with `data-ui="navbar-avatar"`.
    rules.push(
      `${s}[data-ui="navbar"] :not([data-ui="navbar-avatar"], [data-ui="navbar-avatar"] *) { color: ${textColor} !important; }`,
    );
  }
  return rules;
}
